import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { certificateTypeApi } from "./certificateTypeAPI";
import { RootState } from "../../store";

const certificateTypeAdapter = createEntityAdapter<CertificateType>();
const initialCertificateTypeState = certificateTypeAdapter.getInitialState();

const certificateTypeSlice = createSlice({
  name: "certificateType",
  initialState: initialCertificateTypeState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(certificateTypeApi.endpoints.getCertificateTypes.matchFulfilled, (state, action) => {
      certificateTypeAdapter.upsertMany(state, action.payload);
    });
    builder.addMatcher(certificateTypeApi.endpoints.createCertificateType.matchFulfilled, (state, action) => {
      certificateTypeAdapter.addOne(state, action.payload);
    });
    builder.addMatcher(certificateTypeApi.endpoints.deleteCertificateType.matchFulfilled, (state, action) => {
      certificateTypeAdapter.removeOne(state, action.meta.arg.originalArgs.certificate_type_id);
    });
  },
});

export { certificateTypeSlice };
export const {
  selectById: selectCertificateTypeById,
  selectAll: selectAllCertificateTypes,
  selectEntities: selectCertificateTypeEntities,
} = certificateTypeAdapter.getSelectors((state: RootState) => state.certificateType);
